<template>
  <div v-if="loaded">
    <el-row type="flex" class="row-bg" justify="space-between">
      <i class="material-icons">filter_list</i>
      <!-- <s-select
        :options="tanks"
        labelProp="name"
        large
        valueProp="id"
        filterable
        clearable
        placeholder="Φίλτρο δεξαμενής"
        v-model="selectedTank"
      ></s-select>

      <el-button
        type="warning"
        plain
        @click="$refs.fuelSrsTable.appendRecord({status:'cr-load',time:unxnow()})"
        title="Διόρθωση δεξαμενης"
      >
        <i class="material-icons">vertical_align_center</i>
      </el-button>-->
      <el-button
        type="success"
        round
        title="Νεος προμηθευτής/πηγή καυσήμων"
        @click="$refs.fuelSrsTable.appendRecord()"
      >
        +
        <i class="material-icons">store</i>
      </el-button>
    </el-row>
    <s-table
      ref="fuelSrsTable"
      v-if="loaded"
      v-model="fuelSrsTrans"
      :topOffset="75"
      heightWish="90%"
      :pagging="41"
      :colDefinitions="colDefinitions"
      modx-processor="tanks/getlist"
      :r-query="{}"
      :lazyLoader="true"
      :addEmptyLine="false"
      @cell-change="handlefuelSrsTransaction"
      @cell-clicked="removeSrsTransaction"
    ></s-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

export default {
  data() {
    return {

      fuelSrsTrans: [],
      tanks: [],
      printData: null,
      printReady: false,
      loaded: false,
      selectedTank: null,
      page: 1,
      searchall: null,

      todayArrivals: [],
      todayDepartures: [],
      cols: {},
      dateFormat: "DD/MM/YY"
    };
  },
  methods: {

    removeSrsTransaction(e) {
      var vm = this;
      // _log_("hell.RRs..", e);
      // _log_("trans.ss.go ii..", e);
      if (e.column.property == "delete") {
        if (!e.row.id) return;
        this.$confirm(
          "This will permanently delete the record. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        )
          .then(() => {
            api.removeObject("tanks", { objectId: e.row.id });
            vm.removeArrayElement(this.fuelSrsTrans, e.row, "id");
          })
          .catch(() => {});
      }
    },

    async handlefuelSrsTransaction(e) {
      //process before edit

      const data = await api.updateProcessor("tanks/update", e.row);
      // _log_("upd...", data);
      if (data) this.updateArrayElement(this.fuelSrsTrans, data, "id", true);

    },
    async goPrintThis() {
      // var { data } = await api.fetchProcessor("bookings/vuebookings", {
      //   "bookingRange[]": this.bookingRange,
      //   idHotel: this.activeHotel,
      //   searchall: this.searchall,
      //   limit: 0
      // });
      // this.printData = data.results;
      this.loaded = true;
    },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    }
  },
  async mounted() {

    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    // qfuelSrsTransactions() {
    //   return {
    //     "timeRange[]": this.fuelsWorkingRange,
    //     view: "tanks",
    //     selectedTank: this.selectedTank
    //   };
    // },
    // ...mapGetters({
    //   getList: "tags/getList",
    //   fuelsWorkingRange: "user/fuelsWorkingRange"
    // }),

    colDefinitions() {
      var rw = "380px";
      if (window.innerWidth < 500) rw = "150px";
      if (window.innerWidth < 700) rw = "240px";
      if (window.innerWidth < 1000) rw = "300px";
      return [
        {
          prop: "type",
          editable: true,
          formatter(val) {
            if (val == "tank")
              return '<i class="material-icons">ev_station</i>';
            if (val == "external") return '<i class="material-icons">store</i>';
          },
          width: "100px",
          label: "Type",
          editorcomponent: {
            is: "s-select",
            options: [
              { name: "Tank", val: "tank" },
              { name: "Gas Station", val: "external" }
            ],
            labelProp: "name",
            valueProp: "val",
            filterable: true,
            clearable: true
          }
        },
        {
          prop: "name",
          label: "Name",
          editable: true,
          width: "180px"
        },
        {
          prop: "pumps",
          width: "130px",
          label: "Pumps",
          editable: true,
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.type == "tank") return true;
            return false;
          }
        },

        { prop: "comments", editable: true, width: "290px", label: "Σχολια" },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
      ];
    }
  }
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}
.has-more {
  color: red;
  font-weight: 700;
}
</style>
